/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{4CD7B11D-048C-45B7-9919-C9ACA0BFD60D}",
  "sitecoreApiHost": "",
  "jssAppName": "convention",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/sitecore/api/graph/edge",
  "graphQLEndpoint": "/sitecore/api/graph/edge"
};